import { post } from '@/api/axios';
import { CompanyEndpoints } from '@/api/endpoints/CompanyEndpoints';
import { type CompanyDto } from '@/app/models/CompanyDto';
import { type ListData } from '@/app/models/ListData';

// Um ambiente tem poucas empresas: uma página traz todas.
export const listActive = () =>
  post<ListData<CompanyDto>>(CompanyEndpoints.list, { filter: { active: true }, sort: 'social_name', per_page: 100 });
